import React, { useState, useEffect } from 'react';

const Image = ({ src, alt, width, height, className = '', style = {}, ...props }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  const handleImageLoad = () => {
    setLoaded(true);
  };

  const containerStyle = {
    position: 'relative',
    width: width || 'auto',
    height: height || 'auto',
    overflow: 'hidden',
    ...style,
  };

  const imageStyle = {
    opacity: loaded ? 1 : 0,
    transition: 'opacity 0.3s ease',
    objectFit: 'cover',
    objectPosition: 'left top',
    width: '100%',
    height: '100%',
  };

  return (
    <div style={containerStyle} className={className} {...props}>
      <img
        src={src}
        alt={alt}
        style={imageStyle}
        onLoad={handleImageLoad}
        loading="lazy"
      />
    </div>
  );
};

export default Image;